import { useSyncExternalStore } from "react";
import {
  isExcelSkillsEnabled,
  isPowerPointPickerSkillsEnabled,
  subscribePickerSkills,
} from "./pickerSkills";

/** React view of the atomic `skills && xlsxSkills` Excel gate. */
export function useExcelSkillsEnabled(): boolean {
  return useSyncExternalStore(subscribePickerSkills, isExcelSkillsEnabled, () => false);
}

/** React view of the atomic `skills && pptxSkills` gate for shared UI. */
export function usePowerPointPickerSkillsEnabled(): boolean {
  return useSyncExternalStore(
    subscribePickerSkills,
    isPowerPointPickerSkillsEnabled,
    () => false
  );
}
